import dynamic from "next/dynamic";

import Pages from "src/constants/pages";
const Form = dynamic(() => import("./Form"));
const Loading = dynamic(() => import("./Loading"));
import Wrapper from "src/components/layout/wrapper";
import { FacilityUserInfo } from "src/types/facility";
import { useGetUserInfo } from "src/services/jet-card";

export default function Content() {
    const { data, isLoading } = useGetUserInfo();
    return (
        <Wrapper title="جت کارت" toolbarHref={Pages.Main} showToolbar>
            {isLoading ? <Loading /> :
                <Form
                    userInfoData={data?.value as FacilityUserInfo}
                />
            }
        </Wrapper>
    );
};